import { BAY_ISLE, TERRACOTTA, SEMI_SWEET, PROPER_GREY, RULE, WHITE, FONT_DISPLAY, FONT_DISPLAY_HEAVY, FONT_SERIF, FONT_BODY } from "../theme";

const LIVE_PRODUCTS = [
  {
    tag: "Guide",
    name: "Meta Ads + Meta Pixel Guide",
    desc: "Everything you need to run Facebook and Instagram ads that actually convert — including how to set up your Meta Pixel correctly from the start.",
    cta: "Get the guide →",
    href: "https://stan.store/acadiamediamarketing/p/get-my-meta-ads-guide-now-klqeh4rc",
  },
  {
    tag: "Prompt Pack",
    name: "AI Prompt Pack — 30 Prompts",
    desc: "30 copy-and-paste AI prompts built for real estate agents and small businesses. Stop staring at a blank screen — these get you to a first draft in seconds.",
    cta: "Get the prompt pack →",
    href: "https://stan.store/acadiamediamarketing/p/get-my-ai-prompt-pack-30-prompts-now",
  },
];

const COMING_PRODUCTS = [
  {
    tag: "Template",
    name: "AI Content Calendar Template",
    desc: "A plug-and-play content calendar built around AI-produced posts. Plan a full month of content in one sitting.",
  },
  {
    tag: "Cheat Sheet",
    name: "Monthly AI Cheat Sheet",
    desc: "The tools, prompts, and shortcuts worth knowing each month — condensed into one PDF you can actually use.",
  },
];

const IN_PERSON = [
  {
    tag: "Video",
    name: "Reel Filming Session",
    desc: "On-location reel filming for agents and businesses — edited, captioned, and ready to post. Show up on camera, leave with content.",
  },
  {
    tag: "Photography",
    name: "Brand & Listing Photos",
    desc: "Professional photography for listings, storefronts, or brand use. Clean, on-brand, and delivered fast.",
  },
  {
    tag: "Headshots",
    name: "Professional Headshots",
    desc: "Modern headshots for agents and business owners — natural, polished, and ready for your website, business cards, and socials.",
  },
];

const SAAS_TOOLS = [
  {
    name: "Agent AI Voice Tool",
    desc: "Generate listing copy, captions, and more in your own voice. Free to try, with a paid upgrade for full access.",
    badge: "Free + Paid",
  },
  {
    name: "Neighborhood Snapshot Postcard",
    desc: "Auto-generated neighborhood market snapshot postcards — pull the data, drop in your branding, send.",
    badge: "Coming Soon",
  },
  {
    name: "Listing Headline Slider",
    desc: "A fast tool for testing listing headline variations — slide between options and pick what lands.",
    badge: "Coming Soon",
  },
];

function ProductCard({ tag, name, desc, cta, href }) {
  return (
    <div style={{
      background: WHITE, border: `1px solid ${RULE}`, borderRadius: 14,
      padding: "24px 22px", display: "flex", flexDirection: "column",
    }}>
      <p style={{
        fontSize: 9.5, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase",
        color: TERRACOTTA, marginBottom: 10, fontFamily: FONT_BODY,
      }}>{tag}</p>
      <p style={{ fontSize: 16, fontWeight: 700, color: BAY_ISLE, marginBottom: 10, fontFamily: FONT_DISPLAY }}>{name}</p>
      <p style={{ fontSize: 13, color: SEMI_SWEET, lineHeight: 1.7, fontFamily: FONT_BODY, flex: 1, marginBottom: 20 }}>{desc}</p>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: "inline-block", textAlign: "center", padding: "12px 20px", borderRadius: 9,
          background: BAY_ISLE, color: WHITE, textDecoration: "none",
          fontSize: 12, fontWeight: 700, letterSpacing: "0.08em", fontFamily: FONT_BODY,
          transition: "opacity 0.15s",
        }}
      >
        {cta}
      </a>
    </div>
  );
}

function ComingSoonCard({ tag, name, desc }) {
  return (
    <div style={{
      background: "rgba(172,167,166,0.07)", border: `1px dashed ${RULE}`,
      borderRadius: 14, padding: "24px 22px",
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
        <p style={{
          fontSize: 9.5, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase",
          color: PROPER_GREY, fontFamily: FONT_BODY,
        }}>{tag}</p>
        <span style={{
          fontSize: 9, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase",
          padding: "2px 8px", borderRadius: 999, background: "rgba(172,167,166,0.18)", color: PROPER_GREY,
          fontFamily: FONT_BODY,
        }}>Coming soon</span>
      </div>
      <p style={{ fontSize: 16, fontWeight: 700, color: PROPER_GREY, marginBottom: 10, fontFamily: FONT_DISPLAY }}>{name}</p>
      <p style={{ fontSize: 13, color: PROPER_GREY, lineHeight: 1.7, fontFamily: FONT_BODY }}>{desc}</p>
    </div>
  );
}

function SaasCard({ name, desc, badge }) {
  const isFreePaid = badge === "Free + Paid";
  return (
    <div style={{
      background: WHITE, border: `1px solid ${RULE}`, borderRadius: 14, padding: "22px 20px",
    }}>
      <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 10, marginBottom: 10 }}>
        <p style={{ fontSize: 15, fontWeight: 700, color: BAY_ISLE, fontFamily: FONT_DISPLAY }}>{name}</p>
        <span style={{
          fontSize: 9, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase",
          padding: "3px 9px", borderRadius: 999, flexShrink: 0,
          background: isFreePaid ? "rgba(195,135,98,0.12)" : "rgba(172,167,166,0.15)",
          color: isFreePaid ? TERRACOTTA : PROPER_GREY,
          fontFamily: FONT_BODY,
        }}>{badge}</span>
      </div>
      <p style={{ fontSize: 13, color: SEMI_SWEET, lineHeight: 1.65, fontFamily: FONT_BODY }}>{desc}</p>
    </div>
  );
}

export default function Products() {
  return (
    <div style={{ maxWidth: 960, margin: "0 auto", padding: "3.5rem 20px 5rem" }}>

      {/* HEADER */}
      <div style={{ textAlign: "center", marginBottom: "3rem" }}>
        <p style={{
          fontSize: 10, fontWeight: 700, letterSpacing: "0.22em", textTransform: "uppercase",
          color: TERRACOTTA, marginBottom: 16, fontFamily: FONT_BODY,
        }}>
          Digital products
        </p>
        <h1 style={{
          fontFamily: FONT_DISPLAY_HEAVY, fontSize: "clamp(26px, 5vw, 38px)",
          color: BAY_ISLE, lineHeight: 1.2, marginBottom: 14, fontWeight: 400,
        }}>
          Tools built for{" "}
          <em style={{ color: TERRACOTTA, fontStyle: "italic", fontFamily: FONT_SERIF, fontSize: "1.1em" }}>
            how you actually work
          </em>
        </h1>
        <p style={{ fontSize: 14, color: SEMI_SWEET, lineHeight: 1.75, maxWidth: 480, margin: "0 auto", fontFamily: FONT_BODY }}>
          Guides, prompt packs, and tools you can use right now — no agency retainer required.
          The lower-commitment way to start working smarter with AI.
        </p>
      </div>

      {/* LIVE PRODUCTS */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 16, marginBottom: "1rem" }}>
        {LIVE_PRODUCTS.map((p, i) => <ProductCard key={i} {...p} />)}
      </div>

      <p style={{ textAlign: "center", marginBottom: "3rem", marginTop: "1rem" }}>
        <a
          href="https://stan.store/acadiamediamarketing"
          target="_blank"
          rel="noopener noreferrer"
          style={{ fontSize: 12, color: TERRACOTTA, fontWeight: 700, fontFamily: FONT_BODY, textDecoration: "none" }}
        >
          View all products on Stan Store →
        </a>
      </p>

      {/* COMING SOON */}
      <div style={{ marginBottom: "3.5rem" }}>
        <p style={{
          fontSize: 10, fontWeight: 700, letterSpacing: "0.2em", textTransform: "uppercase",
          color: PROPER_GREY, marginBottom: 16, fontFamily: FONT_BODY,
        }}>
          More coming soon
        </p>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 14 }}>
          {COMING_PRODUCTS.map((p, i) => <ComingSoonCard key={i} {...p} />)}
        </div>
      </div>

      {/* IN-PERSON SERVICES */}
      <div style={{ borderTop: `1px solid ${RULE}`, paddingTop: "3rem", marginBottom: "3.5rem" }}>
        <div style={{ marginBottom: "1.75rem" }}>
          <p style={{
            fontSize: 10, fontWeight: 700, letterSpacing: "0.2em", textTransform: "uppercase",
            color: TERRACOTTA, marginBottom: 8, fontFamily: FONT_BODY,
          }}>
            In-person services
          </p>
          <h2 style={{
            fontFamily: FONT_DISPLAY, fontSize: "clamp(20px, 3.5vw, 28px)",
            color: BAY_ISLE, fontWeight: 400, marginBottom: 10,
          }}>
            Show up in person. We handle the rest.
          </h2>
          <p style={{ fontSize: 13.5, color: SEMI_SWEET, lineHeight: 1.75, maxWidth: 500, fontFamily: FONT_BODY }}>
            Hudson Valley–based filming, photography, and headshot sessions — edited and delivered ready to use.
            Pricing is custom. <a href="/get-started" style={{ color: TERRACOTTA, fontWeight: 700, textDecoration: "none" }}>Get in touch</a> to book.
          </p>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 14 }}>
          {IN_PERSON.map((p, i) => (
            <div key={i} style={{ background: WHITE, border: `1px solid ${RULE}`, borderRadius: 14, padding: "22px 20px" }}>
              <p style={{
                fontSize: 9.5, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase",
                color: TERRACOTTA, marginBottom: 10, fontFamily: FONT_BODY,
              }}>{p.tag}</p>
              <p style={{ fontSize: 15, fontWeight: 700, color: BAY_ISLE, marginBottom: 10, fontFamily: FONT_DISPLAY }}>{p.name}</p>
              <p style={{ fontSize: 13, color: SEMI_SWEET, lineHeight: 1.7, fontFamily: FONT_BODY }}>{p.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* SAAS TOOLS SECTION */}
      <div style={{ borderTop: `1px solid ${RULE}`, paddingTop: "3rem" }}>
        <div style={{ marginBottom: "1.75rem" }}>
          <p style={{
            fontSize: 10, fontWeight: 700, letterSpacing: "0.2em", textTransform: "uppercase",
            color: TERRACOTTA, marginBottom: 8, fontFamily: FONT_BODY,
          }}>
            Agent tools — in development
          </p>
          <h2 style={{
            fontFamily: FONT_DISPLAY, fontSize: "clamp(20px, 3.5vw, 28px)",
            color: BAY_ISLE, fontWeight: 400, marginBottom: 10,
          }}>
            Mini SaaS tools for real estate agents
          </h2>
          <p style={{ fontSize: 13.5, color: SEMI_SWEET, lineHeight: 1.75, maxWidth: 540, fontFamily: FONT_BODY }}>
            A suite of lightweight AI tools built specifically for agents — standalone, fast, and designed to save you time on the repetitive parts of listing and marketing work.
          </p>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 14 }}>
          {SAAS_TOOLS.map((t, i) => <SaasCard key={i} {...t} />)}
        </div>
      </div>

    </div>
  );
}
